<template>
  <div class="page-container">
    <div class="query-title">现金奖励使用情况报表</div>
  <div class="content">
    <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
    <div class="table-container">
      <Table-filter
        title="明细"
        :rt-columns="rtColumns1"
        :lt-columns="ltColumns1"
        :grid-columns="gridOptions.columns"
        :count-data="countFileds"
        :all-options="allOptions"
        :pagination="pagination"
        @pagination-change="handleTablePaginationChange"
        @confirm="tableConfigConfirm"
      >
        <template #button>
          <table-button name="export" tip="导出" @click="exportExcel" />
        </template>
        <vxe-grid
          ref="xTable"
          v-loading="loading"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          height="300"
          max-height="600"
          align="center"
          size="mini"
          show-overflow
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :sort-config="{ multiple: true }"
          :empty-render="{name: 'NotData'}"
          :filter-config="{ remote: true }"
          :toolbar-config="{ custom: true, size: 'mini' }"
        :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
          :row-class-name="rowClassName"
          @filter-change="filterChangeEvt"
        >
        </vxe-grid>
      </Table-filter>
    </div>
  </div>
  <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />
</div>
</template>

<script>
import { rewardReport } from '@/api/sap/reward-policy'
import tableMixins from '@/utils/tableMixins'
import pageConfig, { pageSearch } from './config/rewardUserData'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
export default {
mixins: [tableMixins],
components: {
},
data() {
  return {
    pageSearch,
    searchField: {},
    pagination: {
      page: 1,
      pagesize: 50,
      totalCount: 0
    },
    loading: false,
    gridOptions: {
      columns: [
        { type: 'checkbox', field: 'checkbox', title: '', width: 50, align: 'center' },
        ],
      data: []
    },
    modeType: '',
    checkData: [],
    totalAmount: 0,
    confirmBtn: ''
  }
},
props: {
},
created() {
  this.initPage(pageConfig)
},
methods: {
  // 导出全部 导出本页
  async exportExcel() {
    const checkData = this.$refs.xTable.getCheckboxRecords()
    if (checkData.length) {
      frontExport(this.gridOptions.columns, checkData, '销售折扣数据报表')
      return
    }
    const params = {
      user_bp: this.$store.getters.role.USER_BP,
      ...this.allConditions
    }
    const data = await concurrencyReq(this.pagination.totalCount, params, rewardReport)
    frontExport(this.gridOptions.columns, data, '销售折扣数据报表')
  },
  handleTablePaginationChange(pages) {
    Object.assign(this.pagination, pages)
    this.queryData()
  },
  async queryData(page, ranges) {
    if (page === 1) {
      this.pagination.page = page
      if (ranges) {
        // 保存 查询组件的查询参数
        this.ranges = ranges
        this.handleRanges(ranges)
      }
      this.isSetFilter = false
    }
    const params = {
      user_bp: this.$store.getters.role.USER_BP,
      role: this.$store.getters.role.ROLE,
      ...this.pagination,
      is_result: 1,
      sort: this.sortData.concat(this.tableSort),
      ...this.allConditions,
    }
    this.loading = true
    try {
      const { data, total,calculation, field } = await rewardReport(params)
      if (data.length === 0 && (total - 0)) {
        this.queryData(1, ranges)
        return
      }
      this.pagination.totalCount = total - 0
      this.calculation = this.filtercalculation(calculation)
      // 更新计算值
      this.updateCount()
      if (this.showHeader) {
        this.gridOptions.data = this.tableCountData.concat(data)
      } else {
        this.gridOptions.data = data.concat(this.tableCountData)
      }
      this.allOptions = this.filterAllOptions(field)
      this.setFilter()
    } catch (e) {
      //
    }
    this.loading = false
  },
},

}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/reward-policy/reward-user-data.vue